import React from "react";

export const Page5Tamil = () => {
  return (
    <div className="page-tamil-container">
      <p>திரு. எஸ். துரைராஜ் அவர்கள் </p>
      <p>
        நானும் என்னுடைய அன்பு மனைவி பூரணியும் எங்களுடைய செல்வக் குழந்தைகள்
        செல்வன். எஸ்.டி. நரேஷ்குமார், செல்வி. எஸ்.டி. விஸ்வநந்தினி ஆகியோருடன்
        பெங்களூரில் வசிக்கிறோம். என்னுடைய சகோதரர்கள் மற்றும் உறவினர்களும் இங்கு
        வசிக்கிறார்கள்.
      </p>
      <p>
        சுமாராக 80 ஆண்டுகளுக்கு முன் கொளப்பாடு கிராமத்தில் தங்கி என்னுடைய தாத்தா
        வடிவேல் உபாத்தியாயர் பள்ளி ஆசிரியராக பணிபுரிந்திருக்கிறார். என்னுடைய
        தந்தையின் பெயர் டி.வி. சுந்தரேச பாகவதர், தாயின் பெயர் கமலம்மாள்
        அமரராகிவிட்ட என்னுடைய தாத்தா, தந்தை இருவரும் எங்கள் குடும்பங்களுக்கு
        வைத்து விட்டு போயிருக்கும் என்றும் அழியாத சொத்தாக நாங்கள் மதிப்பது
        கொளப்பாடு கிராமத்தில் உள்ள எங்கள் குல தெய்வம் ஸ்ரீ ஆதியண்ணன் மற்றும்
        ஸ்ரீ அய்யனார் ஆகும்
      </p>
      <p>
        நாங்கள் சகோதரர்கள் வெல்வேறு தொழிலில் ஈடுபட்டிருந்தாலும் இன்று வரை எங்களை
        ஒன்றாக இணைத்து வைத்திருக்கும் ஒரு பெரிய சக்தி எங்கள் குல தெய்வம் ஸ்ரீ
        ஆதியண்ணன், ஸ்ரீ அய்யனார் ஆகும். நாங்கள் ஆண்டுக்கு ஒருமுறை குடும்பத்தோடு
        சேர்ந்து இங்கு வந்து குல தெய்வ பூஜை செய்து வருவதை வழக்கமாக கொண்டுள்ளோம்.
      </p>
      <p>
        கொளப்பாடு கிராமத்திலுள்ள இரு கோயில்களுக்கும் திருப்பணி செய்து
        கும்பாபிஷேகம் செய்ய வேண்டும் என்ற எண்ணம் எங்களுக்கு பல ஆண்டுகளாக
        இருந்தது. "எது எது எப்போது யாரால் நடக்க வேண்டுமென்று ஆண்டவன் கட்டளையிடு
        கிறானோ அது அது அப்போதுதான் நடக்கும்” என்ற மொழிக்கேற்ப இந்த ஆண்டு
        கிராமவாசிகளின் அனுமதியுடனும் ஒத்துழைப்புடனும் திருப்பணியும்
        கும்பாபிஷேகமும் சிறப்பாக நடத்தியுள்ளோம்.
      </p>
      <p>
        இந்தப் பணியில் பலரும் எங்களுடன் ஒத்துழைத்தாலும் முக்கியமான ஒருவர் நல்ல
        நண்பராக நல்ல உதவியாளராக தெய்வத் தொண்டு செய்வதில் ஆர்வமுள்ளவராக மிகவும்
        நம்பிக்கைக்கு உகந்தவராக விளங்கும் ஒருவர் கிடைத்தார். அவர்தான்
        கொளப்பாட்டில் சிவசக்தி மளிகை வைத்திருக்கும் அன்பர் ஜி.ரமேஷ் ஆகும். இவர்
        எங்களுக்கு பேருதவியாக இருந்துள்ளார். எங்கள் எண்ணப்படி திருப்பணி வேலைகள்
        செய்து புதிய ஆதியண்ணன் சிலை அமைத்து கண்கவர் வண்ணம் பூசி பணி
        செய்தவர்களுக்கும், கும்பாபிஷேகம் சிறப்பாக நடைபெற ஒத்துழைப்பு தந்த திரு.
        வீரமணி சிவாச்சாரியார் மற்றும் கொளப்பாடு கிராமவாசிகள் மற்றும்
        பக்தர்களுக்கு எங்கள் குடும்பத்தின் சார்பில் என் நன்றியையும்,
        வணக்கத்தையும் தெரிவித்துக் கொள்கிறேன்.
      </p>
      <p>
        கும்பாபிஷேக சிறப்பு மலரை தயாரித்து தந்த ஒய்வு பெற்ற ஆசிரியர் எஸ்.
        வாசுதேவன் அவர்களுக்கும் எங்கள் மனமார்ந்த நன்றியை தெரிவித்துக்
        கொள்கிறேன்.
      </p>
      <p>அமரர் <strong>T.T. சுந்தர பாகவதர்</strong> அவர்கள் குடும்பத்தின் சார்பாக </p>
      <p style={{ fontWeight: "bold" ,margin:0}}>S.துரைராஜ், </p>
      <p style={{margin:0}}>ஆதி எண்டர்பிரைசஸ், பெங்களூர்.</p>
    </div>
  );
};
